import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaEnvelope } from 'react-icons/fa'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Ready to take the plunge? <a href="/contact">Contact us</a> today!</p>
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61574078212774" target="_blank" rel="noopener noreferrer"><FaFacebookF/></a>
          {/*<a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer"><FaEnvelope/></a>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
